import { formatDuration } from '@/components/contentPane/voiceErrors';
import { useTranslation } from 'react-i18next';

/** Telegram-style hold-to-record HUD: pulsing dot + timer + a live hint.
 *  Releasing the mic sends; releasing with the cursor outside the composer
 *  cancels. The bar flips to a "cancel" look while in the cancel zone. */
export function RecordingHud(props: { durationMs: number; willCancel: boolean }) {
  const { t } = useTranslation();
  return (
    <div
      className={
        'mb-1.5 flex items-center gap-3 rounded-xl px-3 py-2 transition-colors ' +
        (props.willCancel ? 'bg-danger/20' : 'bg-danger/10')
      }
    >
      <span aria-hidden className="relative flex h-3 w-3 shrink-0 items-center justify-center">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-danger/60" />
        <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-danger" />
      </span>
      <span className="font-mono text-sm tabular-nums text-foreground">
        {formatDuration(props.durationMs)}
      </span>
      <span className="flex-1" />
      <span className={'text-xs ' + (props.willCancel ? 'font-medium text-danger' : 'text-ink-muted')}>
        {props.willCancel ? t('composer.releaseToCancel') : t('composer.releaseToSend')}
      </span>
    </div>
  );
}
